module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_new_subject_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subjectName),
      expression: "subjectName"
    }],
    ref: "d_title_input",
    staticClass: "d-input",
    staticStyle: {
      "height": "34px"
    },
    attrs: {
      "id": "d-title-input-for-new-subject"
    },
    domProps: {
      "value": (_vm.subjectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subjectName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.choose_subject_type')))]), _vm._v(" "), _c('SubjectFormSubjectType', {
    attrs: {
      "calendarType": 'user'
    },
    on: {
      "change": _vm.setSubjectType
    }
  })], 1), _vm._v(" "), (!_vm.isLoadingUserSchools && _vm.isUserHasMultipleSchools) ? _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.choose_school')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theActiveSchoolId),
      expression: "theActiveSchoolId"
    }],
    staticClass: "d-select-with-options",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.theActiveSchoolId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.userSchools), function(school) {
    return _c('option', {
      key: school.id,
      domProps: {
        "value": school.id
      }
    }, [_vm._v("\n            " + _vm._s(school.name) + "\n          ")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-777a068e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/CreateEvent/CreateEventNewSubject.vue
// module id = 2017
// module chunks = 1